import React from 'react';
import * as Routes from '@/modules/routes';
import I18n from '@/modules/i18n';
import DropdownButton from '@/components/ui/Dropdown/DropdownButton';
import readingLevelIcon from 'images/icons/reading-level.svg';
import ButtonWithDropdown from '../Button/ButtonWithDropdown';

type IReadingLevel = 'a' | 'b';

const LEVEL_LABELS: Record<IReadingLevel, { staffer: string; student: string }> = {
  a: { staffer: 'A', student: I18n.t('standard') },
  b: { staffer: 'B', student: I18n.t('leveled') },
};

interface ReadingLevelButtonProps {
  inIframe?: boolean;
  isStaffer: boolean;
  programId: number;
  readingLevel: IReadingLevel;
  sectionId: number;
}

const ReadingLevelButton = ({
  inIframe = false, isStaffer, programId, readingLevel, sectionId,
}: ReadingLevelButtonProps) => {
  const pathForReadingLevel = (level: IReadingLevel) => (
    Routes.shared_section_path(sectionId, {
      in_iframe: inIframe,
      program_id: programId,
      reading_level: level,
    })
  );

  const labelFor = (level: IReadingLevel) => (
    isStaffer ? LEVEL_LABELS[level].staffer : LEVEL_LABELS[level].student
  );

  return (
    <div className="tw-flex">
      <ButtonWithDropdown
        ariaLabel={I18n.t('select_reading_level')}
      >
        <ButtonWithDropdown.ButtonContent>
          <img
            alt="Select reading level"
            className="standard"
            src={readingLevelIcon}
          />
        </ButtonWithDropdown.ButtonContent>
        <ButtonWithDropdown.DropdownContent>
          <>
            {(['a', 'b'] as IReadingLevel[]).map(level => (
              <DropdownButton
                key={level}
                checkmarkPlacement="left"
                href={pathForReadingLevel(level)}
                selected={readingLevel.toLocaleLowerCase() === level}
                title={`English reading level ${labelFor(level)}`}
                type="link"
              >
                <span>{labelFor(level)}</span>
              </DropdownButton>
            ))}
          </>
        </ButtonWithDropdown.DropdownContent>
      </ButtonWithDropdown>
    </div>
  );
};

export default ReadingLevelButton;
